"use strict";

exports.__esModule = true;
exports.RenderGroup = exports.DropdownCheckboxListContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _reactWindow = require("react-window");
var _RenderItem = require("./RenderItem");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
var _helper = require("./helper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var DropdownCheckboxListContainer = exports.DropdownCheckboxListContainer = _styledComponents["default"].div.withConfig({
  displayName: "RenderGroup__DropdownCheckboxListContainer",
  componentId: "sc-1rgtq2m-0"
})([".", "{align-items:center;}.", "{width:16px;height:16px;box-shadow:inset 0 0 0 1px rgba(16,22,26,0.4),inset 0 -1px 0 rgba(16,22,26,0.2);background-color:", ";background-image:linear-gradient( to bottom,rgba(255,255,255,0.1),rgba(255,255,255,0) );display:flex;align-items:center;justify-content:center;border-radius:3px;font-size:16px;.", "{color:#ffffff;}}"], _core.Classes.MENU_ITEM, _core.Classes.CONTROL_INDICATOR, (0, _Theme.val)("bp6-intent-primary"), _core.Classes.ICON);
var heightOfSubMenu = function heightOfSubMenu(groupItems) {
  var totalItems = groupItems.length;
  if (totalItems * 30 > 300) {
    return 300;
  }
  return totalItems * 30;
};
var RenderGroup = exports.RenderGroup = function RenderGroup(props) {
  var groupItem = props.groupItem,
    style = props.style,
    onSelect = props.onSelect,
    renderGroupText = props.renderGroupText,
    getSelectedItems = props.getSelectedItems,
    handleSelect = props.handleSelect;
  var groupKey = groupItem.groupKey,
    isSelected = groupItem.isSelected,
    groupItems = groupItem.groupItems,
    group = groupItem.group,
    areSomeItemsSelected = groupItem.areSomeItemsSelected;
  var height = heightOfSubMenu(groupItems);
  var handleClick = function handleClick() {
    var selectedItems = getSelectedItems();
    if (isSelected) {
      onSelect(selectedItems.filter(function (item) {
        return !group(item);
      }));
    } else {
      onSelect(selectedItems.concat(groupItems.filter(function (item) {
        return !selectedItems.includes(item);
      })));
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    key: "GROUP:" + groupKey,
    "data-testid": "group-" + groupKey,
    text: typeof renderGroupText === "function" ? renderGroupText(groupKey) : groupKey,
    shouldDismissPopover: false,
    icon: /*#__PURE__*/_react["default"].createElement(GroupIcon, {
      isSelected: isSelected,
      areSomeItemsSelected: areSomeItemsSelected
    }),
    popoverProps: {
      usePortal: true
    },
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement(DropdownCheckboxListContainer, {
    style: {
      top: style.top
    }
  }, /*#__PURE__*/_react["default"].createElement(RenderSubMenu, _extends({}, props, {
    handleSelect: handleSelect,
    items: groupItems,
    height: height
  })))));
};
var GroupIcon = function GroupIcon(props) {
  var isSelected = props.isSelected,
    areSomeItemsSelected = props.areSomeItemsSelected;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: _core.Classes.CONTROL_INDICATOR
  }, isSelected ? /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: _icons.IconNames.SMALL_TICK
  }) : areSomeItemsSelected ? /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: _icons.IconNames.SMALL_MINUS
  }) : /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: _icons.IconNames.BLANK
  }));
};
var RenderSubMenu = function RenderSubMenu(props) {
  var items = props.items,
    _props$height = props.height,
    height = _props$height === void 0 ? 100 : _props$height,
    renderItemText = props.renderItemText,
    renderItemLabel = props.renderItemLabel,
    handleSelect = props.handleSelect;
  var width = (0, _helper.useWidth)(renderItemText, renderItemLabel, items, 300);
  return /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, {
    height: height,
    width: width,
    itemCount: items.length,
    itemSize: 30
  }, function (_ref) {
    var index = _ref.index,
      style = _ref.style;
    var item = items[index];
    return /*#__PURE__*/_react["default"].createElement(_RenderItem.RenderItem, _extends({}, props, {
      item: item,
      handleSelect: handleSelect,
      style: style
    }));
  });
};